/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Horse(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M202.053,54.97754A103.25514,103.25514,0,0,0,128.00009,24h-8a8.00009,8.00009,0,0,0-8,8V59.52979L11.80743,121.18652a8.00038,8.00038,0,0,0-2.29591,11.49317L23.29867,151.7959a31.8353,31.8353,0,0,0,31.338,12.82324c13.6514-2.31055,38.5919-4.23193,61.52457,6.19092L90.02246,207.40479a87.94472,87.94472,0,0,1-20.68657-13.81055A8.00032,8.00032,0,0,0,58.664,205.51611,103.66177,103.66177,0,0,0,128.01279,232q1.043,0,2.0879-.02051A104.001,104.001,0,0,0,202.053,54.97754ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z" />
    </Svg>
  );
}

export default Horse;
